import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";

import { RegisterComponent } from "./components/register/register.component";
import { LoginComponent } from "app/auth/components/login/login.component";
import { ActivateComponent } from "./components/activate/activate.component";
import { ForgotPasswordComponent } from "./components/forgot-password/forgot-password.component";
import { PasswordResetComponent } from "./components/password-reset/password-reset.component";
import { GuestComponent } from './components/guest/guest.component';
import { ResendComponent } from './resend/resend.component';

const routes: Routes = [
  { path: "login", component: LoginComponent, pathMatch: "full" },
  { path: "register", component: RegisterComponent, pathMatch: "full" },
  { path: "activate", component: ActivateComponent },
  { path: "password/forgot", component: ForgotPasswordComponent },
  { path: "password/reset", component: PasswordResetComponent },
  { path: "guest", component: GuestComponent }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    LoginComponent,
    RegisterComponent,
    ActivateComponent,
    ForgotPasswordComponent,
    PasswordResetComponent,
    GuestComponent,
    ResendComponent
  ]
})
export class AuthModule {}
